import { Grid, Typography } from "@material-ui/core";
import SanitizedGrid from "components/SanitizedGrid";
import StatusField from "components/StatusField";
import React, { Fragment } from "react";
import {
  Datagrid,
  Filter,
  TextField,
  SearchInput,
  BulkDeleteButton,
  FunctionField,
  SelectInput,
  ListProps,
  BulkActionProps,
} from "react-admin";
import { statusList } from "./const";
import { GridinRow, GridLabel } from "utils/style";
import CustomDateField from "components/CustomDateField";
import { getUserIdFilterBasedOnRole } from "utils/tools";
import ListShowButton from "../../components/ListShowButton";
import ListEditButton from "../../components/ListEditButton";
import ListWrapper from "../../components/ListWrapper";
import ActionsMenu from "../../components/ActionsMenu";

const SchoolFilter = (props: any) => (
  <Filter {...props}>
    <SearchInput source="search" alwaysOn />
    <SelectInput label="Status" source="Status" choices={statusList} alwaysOn />
  </Filter>
);

const BulkActionButtons = (props: BulkActionProps) => (
  <Fragment>
    <BulkDeleteButton {...props} />
  </Fragment>
);

const SchoolList = (props: ListProps) => {
  const breadcrumb = [{ link: "/schools", title: "Schools" }];

  return (
    <>
      <ListWrapper
        breadcrumb={breadcrumb}
        headerTitle="Schools Management"
        isNotHaveSchoolFilter
        exporter={false}
        filters={<SchoolFilter />}
        filter={getUserIdFilterBasedOnRole()}
        sort={{ field: "status", order: "ASC" }}
        bulkActionButtons={<BulkActionButtons />}
        {...props}
      >
        <Datagrid>
          <FunctionField
            label="School Info"
            render={() => (
              <SanitizedGrid container spacing={2}>
                <Grid item xs={12} style={GridinRow}>
                  <Typography variant="body2" style={GridLabel}>
                    Id :
                  </Typography>

                  <TextField source="id" emptyText="-" />
                </Grid>
                <Grid item xs={12} style={GridinRow}>
                  <Typography variant="body2" style={GridLabel}>
                    Name :
                  </Typography>

                  <TextField source="name" emptyText="-" />
                </Grid>

                <Grid item xs={12} style={GridinRow}>
                  <Typography variant="body2" style={GridLabel}>
                    Email :
                  </Typography>

                  <TextField source="email" emptyText="-" />
                </Grid>

                <Grid item xs={12} style={GridinRow}>
                  <Typography variant="body2" style={GridLabel}>
                    Contact No. :
                  </Typography>

                  <TextField source="phone" emptyText="-" />
                </Grid>
              </SanitizedGrid>
            )}
          />
          <FunctionField
            label="Address"
            render={(record: any) => (
              <SanitizedGrid container spacing={2}>
                <Grid item xs={12} style={GridinRow}>
                  <Typography variant="body2" style={GridLabel}>
                    Block No. :
                  </Typography>

                  <TextField source="blockNumber" emptyText="-" />
                </Grid>

                {record.address !== null && (
                  <Grid item xs={12} style={GridinRow}>
                    <Typography variant="body2" style={GridLabel}>
                      Address :
                    </Typography>

                    <TextField source="address" emptyText="-" />
                  </Grid>
                )}

                {record.unitNumber !== null && (
                  <Grid item xs={12} style={GridinRow}>
                    <Typography variant="body2" style={GridLabel}>
                      Unit No. :
                    </Typography>

                    <TextField source="unitNumber" emptyText="-" />
                  </Grid>
                )}

                {record.building !== null && (
                  <Grid item xs={12} style={GridinRow}>
                    <Typography variant="body2" style={GridLabel}>
                      Building Name :
                    </Typography>

                    <TextField source="building" emptyText="-" />
                  </Grid>
                )}

                <Grid item xs={12} style={GridinRow}>
                  <Typography variant="body2" style={GridLabel}>
                    Postal Code :
                  </Typography>

                  <TextField source="postalCode" emptyText="-" />
                </Grid>
              </SanitizedGrid>
            )}
          />
          <CustomDateField source="createdAt" isDateTime />
          <StatusField source="status" />
          <FunctionField
            label="Actions"
            render={(record: any) => (
              <ActionsMenu
                render={[
                  <ListShowButton record={record} />,
                  <ListEditButton record={record} />,
                ]}
              />
            )}
          />
        </Datagrid>
      </ListWrapper>
    </>
  );
};

export default SchoolList;
